<!-- 服务项目信息编辑页 -->
<template>
	<div class="edit white">
		<el-dialog :title="addEditTitle" :visible.sync="addEditShow" width="700px" :before-close="handleChangeDrawer" :close-on-click-modal="false">
			<div class="pay-mains">
				<el-form ref="formRef" :model="form" class="demo-ruleForm" label-width="120px" label-position="left">
					<el-row>
						<el-col :span="12">
							<el-form-item class="el-form-item-update" ref="bankCardAccountType" label="账户类型：" required="">
								<el-select v-model="form.bankCardAccountType" placeholder="请选择" class="w100b" @change="selectChange">
									<el-option label="本人账户" value="myAccount"></el-option>
									<el-option label="他人账户" value="otherAccount"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item
								class="el-form-item-update"
								ref="agentStaffNo"
								label="受委托人："
								prop="agentStaffNo"
								:rules="$rules.required"
								v-if="form.bankCardAccountType == 'otherAccount'"
							>
								<div class="flex-row">
									<el-input placeholder="请输入店员手机号/工号" v-model="form.agentStaffNo">
										<el-button slot="suffix" size="mini" type="primary" class="cur elButton" @click="searchStaff">查询</el-button>
									</el-input>
								</div>
							</el-form-item>
						</el-col>
						<el-col :span="12" v-if="form.bankCardAccountType == 'otherAccount'">
							<el-form-item class="el-form-item-update" ref="accountName" label="姓名：" prop="accountName">
								{{ form.accountName }}
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item class="el-form-item-update" ref="bankId" label="选择银行：" prop="bankId" :rules="$rules.required">
								<el-select v-model="form.bankId" class="w100b" @change="bankChange" :disabled="form.bankCardAccountType == 'otherAccount' ? true : false">
									<el-option v-for="(item, index) in columns" :key="index" :label="item.name" :value="item.id"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item
								class="el-form-item-update"
								ref="bankName"
								label="银行名称："
								prop="bankName"
								:rules="$rules.required"
								v-if="otherBankShow"
							>
								<el-input v-model="form.bankName" placeholder="请输入银行名称" maxlength="20" :disabled="form.bankCardAccountType == 'otherAccount' ? true : false"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item class="el-form-item-update" label="开户行：" prop="subBankName" :rules="!userInfo.shopBizConfig.yuanyuanFlag || form.bankCardAccountType == 'otherAccount' ? $rules.required : $rules.changeIred">
								<el-input placeholder="请输入开户行" v-model="form.subBankName" maxlength="50" :disabled="form.bankCardAccountType == 'otherAccount' ? true : false" v-if="!userInfo.shopBizConfig.yuanyuanFlag || form.bankCardAccountType == 'otherAccount'"></el-input>
                <el-input readonly v-model="form.subBankName" placeholder="请选择开户行" @focus="onBankNo" v-else></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item class="el-form-item-update" ref="bankCardNo" label="银行卡号：" prop="bankCardNo" :rules="$rules.required">
								<el-input
									placeholder="请输入银行卡号"
									v-model="form.bankCardNo"
									maxlength="19"
									:disabled="form.bankCardAccountType == 'otherAccount' ? true : false"
								></el-input>
							</el-form-item>
						</el-col>
            <el-col :span="12" v-if="userInfo.shopBizConfig.yuanyuanFlag">
							<el-form-item class="el-form-item-update" ref="bankMobile" label="银行预留手机号：" label-width="160px" prop="bankMobile" :rules="$rules.required">
								<el-input
									:placeholder="form.bankCardAccountType == 'otherAccount' ? '':'请输入银行预留手机号'"
									v-model="form.bankMobile"
									maxlength="11"
                  :disabled="form.bankCardAccountType == 'otherAccount'"
								></el-input>
							</el-form-item>
						</el-col>

            <el-col :span="12" v-if="userInfo.shopBizConfig.yuanyuanFlag && form.bankCardAccountType == 'myAccount'">
							<el-form-item class="el-form-item-update" label="联行号查询截图：" label-width="160px" required="">
								<imgUpload
                  @file="getFile"
                  :limit="1"
                  :fileList="form.bankNoImg ? [form.bankNoImg]:[]"
                  @delete="handleDelete"
                  module="bankNo"
                ></imgUpload>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<div class="btns">
					<el-button type="primary" @click="save">确定</el-button>
				</div>
			</div>
		</el-dialog>
    <add-bank-no ref="bankNoRef" @change="bankBack"></add-bank-no>
	</div>
</template>

<script>
import minxin from '../../../assets/javascript/minxin.js'
import addBankNo from './addBankNo.vue';
import imgUpload from '../../../components/common/modules/upload'
export default {
	data() {
		return {
			codeName: true,
			time: 60,
			addEditShow: false,
			addEditTitle: '',
			form: {
				bankCardAccountType: 'myAccount', //
				agentStaffName: '', //
				accountName: '', //
				bankName: '', //
        subBankName: '', //
        bankNo: '',
        bankId: "",
        bankCardNo: '',
        bankMobile: '',
        agentStaffNo: '',
        bankNoImg: ''
			},
			oldForm: {},
			otherBankShow: false,
      columns: [],
      userInfo: {
        shopBizConfig: {

        }
      },
		}
	},
	mixins: [minxin],
	components: {addBankNo, imgUpload},
	computed: {},
	created() {
		this.init()
	},
	methods: {
		searchStaff() {
			// 查询
			this.$api.get(this.$url.companyShopStaff.getBankCardNo, { staffNoOrMobile: this.form.agentStaffNo }).then((res) => {
				if (res) {
					console.log(res)
					this.form.agentStaffId = res.agentStaffId
					this.form.agentStaffName = res.agentStaffName
					this.form.accountName = res.accountName || res.agentStaffName
					this.form.bankCardNo = res.bankCardNo
					this.form.bankId = Number(res.bankId)
					this.form.bankName = res.bankName
          this.form.subBankName = res.subBankName
          this.form.bankNo = res.bankNo
					this.form.bankMobile = res.bankMobile
				}
			})
			// sessionStorage.setItem("bankData", JSON.stringify({
			//   accountName: accountName,
			//   bankCardNo: bankCardNo,
			//   bankName: bankName,
			//   subBankName: subBankName,
			//   bankCardAccountType: bankCardAccountType,
			//   agentStaffName: agentStaffName
			// }))
		},
		//  页面初始化函数
		init() {
			this.$on('set', function(item) {
        Object.assign(this.$data, this.$options.data())
				if (item) {
					this.oldForm = item
          this.form = JSON.parse(JSON.stringify(item))
          this.form.bankId = this.form.bankId ? Number(this.form.bankId) : ''
        }
        this.userInfo = this.$store.getters.ShopInfo;
				this.addEditShow = true
				this.addEditTitle = '银行卡号'
				this.getBankList()
			})
		},
		getBankList() {
			this.$api.post(this.$url.companyStaff.bankList, { belongType: 'part'}).then((res) => {
				if (res) {
					res.map((item) => {
						if (this.form.bankId == item.id && item.name == '其他') {
							this.otherBankShow = true
						}
					})
					this.columns = res
				}
			})
		},
		bankChange(val) {
			console.log(val)
      this.otherBankShow = false;
			this.columns.map((item) => {
				if (val == item.id && item.name == '其他') {
          this.form.bankName = '';
          this.form.bankFullName = '';
          this.otherBankShow = true;
        } else if (val == item.id) {
          this.form.bankId = val;
          this.form.bankName = item.name;
          this.form.bankFullName = item.fullName;
				}
      })
      this.form.bankNo = '';
      this.form.subBankName = '';
		},
		selectChange() {
			this.otherBankShow = false
      console.log(this.form);
      this.form.agentStaffName = ''
      this.form.accountName = ''
      this.form.bankId = ''
      this.form.bankName = ''
      this.form.subBankName = ''
      this.form.bankNo = ''
      this.form.bankCardNo = ''
      this.form.bankMobile = ''
      this.form.bankFullName = ''
      this.form.bankNoImg = ''
      this.$set(this.form, 'agentStaffNo', '')
    },
    onBankNo () {
      if (!this.form.bankName) {
				return this.$message.error('请选择银行名称')
			}
      this.$refs.bankNoRef.open({bankName: this.form.bankFullName || this.form.bankName})
    },
    bankBack (val) {
      if (!val) return
      this.form.subBankName = val.subBankName
      this.form.bankNo = val.bankNo
    },
		handleChangeDrawer(val) {
			// this.$refs["form"].clearValidate();
			this.addEditShow = false
    },
    // 上传组件成功回调
    getFile (res) {
      console.log(res);
      this.form.bankNoImg = res.newImgUrl;
      console.log(this.form);
		},
    handleDelete(res) {
      this.form.bankNoImg = '';
    },
		// 保存
		save() {
			if (!this.form.agentStaffName && this.form.bankCardAccountType == 'otherAccount') {
				return this.$message.error('请输入店员手机号/工号查询')
			} else if (!this.form.bankCardAccountType) {
				return this.$message.error('请选择银行卡类型')
			} else if (!this.form.bankName) {
				return this.$message.error('请输入银行名称')
			} else if (!this.form.subBankName) {
				return this.$message.error('请输入开户行')
			} else if (!this.form.bankCardNo) {
				return this.$message.error('请输入银行卡号')
			} else if (!this.form.bankMobile && this.userInfo.shopBizConfig.yuanyuanFlag && this.form.bankCardAccountType == 'otherAccount') {
				return this.$message.error('请输入银行预留手机号')
      }

      if (this.userInfo.shopBizConfig.yuanyuanFlag && this.form.bankCardAccountType == 'myAccount') {
        if ((!this.form.bankMobile || this.form.bankMobile.length < 11)) {
          this.$message.error('请委托人完善银行预留手机号');
          return false;
        } else if (!this.form.bankNoImg) {
          this.$message.error('请上传银行联号查询截图');
          return false;
        }
      }
      
      this.addEditShow = false
      console.log(this.form);
			sessionStorage.setItem('bankData', JSON.stringify(this.form))
			this.$emit('change', true)
    },
	},
}
</script>
<style scoped lang="less">
@import '../../../assets/css/edit.less';
.pay-mains {
	padding: 0;
	height: 100%;
	/deep/ .el-form-item__content {
		width: 250px !important;
	}
	/deep/ .el-input__suffix {
		right: 10px;
	}
	.elButton {
		height: 30px;
	}
	/deep/ .el-form {
		padding-bottom: 20px;
		/deep/ .el-form-item {
			background: #fff;
			//   border-bottom: 1px solid @borderColor;
			padding: 10px 0;
			// margin-bottom: 0;
			&:last-child {
				border-bottom: 0;
			}
		}
	}
}
</style>
